import Vue from "vue";
import VueRouter from "vue-router";
import { isUserLoggedIn } from "../auth/utils";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/pages/Home.vue"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/pages/authentication/Register.vue"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/pages/authentication/Login.vue"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/fileupload",
    name: "File Upload",
    component: () => import("../views/pages/FileUpload.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/species",
    name: "Species",
    component: () => import("../views/pages/Species.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/experiments",
    name: "Experiments",
    component: () => import("../views/pages/Experiments.vue"),
    meta: {
      auth: true,
    },
  },
  // {
  //   path: "/",
  //   component: () => import("@/views/pages/auth/Auth"),
  //   children: [
  //     {
  //       name: "login",
  //       path: "/login",
  //       component: () => import("@/views/pages/auth/Login"),
  //     },
  //     {
  //       name: "forgot-password",
  //       path: "forgot-password",
  //       component: () => import("@/views/pages/auth/forgot-pass"),
  //     },
  //   ],
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn();
  if (!isLoggedIn && to.meta.auth && to.path !== "/login") {
    return next({ name: "Login" });
  }
  if (isLoggedIn && !to.meta.auth && to.path === "/login") {
    return next({ name: "Home" });
  }
  return next();
});

export default router;
